/**
 * AdminConfig
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {AdminConfigCollection} from '@/model/collection/AdminConfigCollection'

const sha1 = require('sha1')

/* TODO: review generated class */
export class AdminConfig extends Resource {
  idConfigPk: number = 0

  autorizarMesmoVencido: boolean | null = null
  utilizarSmsZenvia: boolean | null = null
  salvarLogsRequestSSW: boolean | null = null
  permitirNotificacaoEmailAtlas: boolean | null = null
  permitirNotificacaoSmsAtlas: boolean | null = null

  senhaApp: string | null = null
  senhaPainel: string | null = null
  indiqueUmAmigo: string | null = null
  boasVindas: string | null = null

  raioAuditoriaCheckinMetros: number | null = null
  raioAuditoriaEntregaMetros: number | null = null

  nomeUltimaAlteracao: string | null = null
  dataUltimaAlteracao: string | null = null

  get $id() {
    return this.idConfigPk
  }
  set $id(val) {
    this.idConfigPk = val
  }

  /**
   * Gets a instance of a given ID of AdminConfig
   */
  async getAdminConfig(id: number) {
    return await Request.get(`/admin/admin-config/${id}`)
      .name('getAdminConfig')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of AdminConfig
   */
  static async listAdminConfig(params: any) {
    return await Request.get(`/admin/admin-config`, {params})
      .name('listAdminConfig')
      .as(AdminConfigCollection)
      .getData()
  }

  /**
   * Persists a new instance of AdminConfig. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAdminConfig() {
    const request = this.$clone()
    request.senhaApp = this.senhaApp ? sha1(this.senhaApp) : null
    request.senhaPainel = this.senhaPainel ? sha1(this.senhaPainel) : null

    return await Request.post(`/admin/admin-config`, request)
      .name('persistAdminConfig')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of AdminConfig to use it in a CSV file
   */
  static async listCsvAdminConfig(params: any) {
    return await Request.get(`/admin/admin-config/csv`, {params})
      .name('listCsvAdminConfig')
      .as(AdminConfigCollection)
      .getData()
  }
}
